export const MIXED_BREED = "Mixed breed / crossbreed"
export const UNKNOWN_BREED = "Unknown / not sure"

export type DogBreedEntry = {
  id: string
  name: string
  group: string
  aliases: string[]
}

export const DOG_BREED_CATALOG: readonly DogBreedEntry[] = [
  { id: "BR-001", name: "Afghan Hound", group: "Hound", aliases: [] },
  { id: "BR-002", name: "Basset Hound", group: "Hound", aliases: [] },
  { id: "BR-003", name: "Beagle", group: "Hound", aliases: [] },
  { id: "BR-004", name: "Bloodhound", group: "Hound", aliases: [] },
  { id: "BR-005", name: "Borzoi", group: "Hound", aliases: [] },
  { id: "BR-006", name: "Dachshund", group: "Hound", aliases: [] },
  { id: "BR-007", name: "Foxhound", group: "Hound", aliases: [] },
  { id: "BR-008", name: "Greyhound", group: "Hound", aliases: [] },
  { id: "BR-009", name: "Italian Greyhound", group: "Hound", aliases: [] },
  { id: "BR-010", name: "Irish Wolfhound", group: "Hound", aliases: [] },
  { id: "BR-011", name: "Rhodesian Ridgeback", group: "Hound", aliases: [] },
  { id: "BR-012", name: "Saluki", group: "Hound", aliases: [] },
  { id: "BR-013", name: "Scottish Deerhound", group: "Hound", aliases: [] },
  { id: "BR-014", name: "Whippet", group: "Hound", aliases: [] },
  { id: "BR-015", name: "American Water Spaniel", group: "Sporting", aliases: [] },
  { id: "BR-016", name: "Boykin Spaniel", group: "Sporting", aliases: [] },
  { id: "BR-017", name: "Brittany", group: "Sporting", aliases: [] },
  { id: "BR-018", name: "Chesapeake Bay Retriever", group: "Sporting", aliases: [] },
  { id: "BR-019", name: "Clumber Spaniel", group: "Sporting", aliases: [] },
  { id: "BR-020", name: "Cocker Spaniel", group: "Sporting", aliases: [] },
  { id: "BR-021", name: "English Setter", group: "Sporting", aliases: [] },
  { id: "BR-022", name: "English Springer Spaniel", group: "Sporting", aliases: [] },
  { id: "BR-023", name: "Field Spaniel", group: "Sporting", aliases: [] },
  { id: "BR-024", name: "Flat-Coated Retriever", group: "Sporting", aliases: [] },
  { id: "BR-025", name: "Golden Retriever", group: "Sporting", aliases: [] },
  { id: "BR-026", name: "Gordon Setter", group: "Sporting", aliases: [] },
  { id: "BR-027", name: "Irish Setter", group: "Sporting", aliases: [] },
  { id: "BR-028", name: "Irish Water Spaniel", group: "Sporting", aliases: [] },
  { id: "BR-029", name: "Labrador Retriever", group: "Sporting", aliases: ["Lab"] },
  { id: "BR-030", name: "Nova Scotia Duck Tolling Retriever", group: "Sporting", aliases: [] },
  { id: "BR-031", name: "Pointer", group: "Sporting", aliases: [] },
  { id: "BR-032", name: "Portuguese Water Dog", group: "Sporting", aliases: [] },
  { id: "BR-033", name: "Spinone Italiano", group: "Sporting", aliases: [] },
  { id: "BR-034", name: "Vizsla", group: "Sporting", aliases: [] },
  { id: "BR-035", name: "Weimaraner", group: "Sporting", aliases: [] },
  { id: "BR-036", name: "Akita", group: "Working", aliases: [] },
  { id: "BR-037", name: "Alaskan Malamute", group: "Working", aliases: [] },
  { id: "BR-038", name: "Anatolian Shepherd Dog", group: "Working", aliases: [] },
  { id: "BR-039", name: "Bernese Mountain Dog", group: "Working", aliases: [] },
  { id: "BR-040", name: "Black Russian Terrier", group: "Working", aliases: [] },
  { id: "BR-041", name: "Boerboel", group: "Working", aliases: [] },
  { id: "BR-042", name: "Boxer", group: "Working", aliases: [] },
  { id: "BR-043", name: "Bullmastiff", group: "Working", aliases: [] },
  { id: "BR-044", name: "Cane Corso", group: "Working", aliases: [] },
  { id: "BR-045", name: "Chinook", group: "Working", aliases: [] },
  { id: "BR-046", name: "Doberman Pinscher", group: "Working", aliases: [] },
  { id: "BR-047", name: "Dogue de Bordeaux", group: "Working", aliases: [] },
  { id: "BR-048", name: "Great Dane", group: "Working", aliases: [] },
  { id: "BR-049", name: "Great Pyrenees", group: "Working", aliases: [] },
  { id: "BR-050", name: "Leonberger", group: "Working", aliases: [] },
  { id: "BR-051", name: "Mastiff", group: "Working", aliases: [] },
  { id: "BR-052", name: "Newfoundland", group: "Working", aliases: [] },
  { id: "BR-053", name: "Rottweiler", group: "Working", aliases: [] },
  { id: "BR-054", name: "Samoyed", group: "Working", aliases: [] },
  { id: "BR-055", name: "Siberian Husky", group: "Working", aliases: [] },
  { id: "BR-056", name: "St. Bernard", group: "Working", aliases: [] },
  { id: "BR-057", name: "Tibetan Mastiff", group: "Working", aliases: [] },
  { id: "BR-058", name: "Australian Cattle Dog", group: "Herding", aliases: [] },
  { id: "BR-059", name: "Australian Shepherd", group: "Herding", aliases: [] },
  { id: "BR-060", name: "Bearded Collie", group: "Herding", aliases: [] },
  { id: "BR-061", name: "Belgian Malinois", group: "Herding", aliases: [] },
  { id: "BR-062", name: "Belgian Sheepdog", group: "Herding", aliases: [] },
  { id: "BR-063", name: "Belgian Tervuren", group: "Herding", aliases: [] },
  { id: "BR-064", name: "Border Collie", group: "Herding", aliases: [] },
  { id: "BR-065", name: "Cardigan Welsh Corgi", group: "Herding", aliases: [] },
  { id: "BR-066", name: "Collie", group: "Herding", aliases: [] },
  { id: "BR-067", name: "German Shepherd Dog", group: "Herding", aliases: ["Alsatian"] },
  { id: "BR-068", name: "Miniature American Shepherd", group: "Herding", aliases: [] },
  { id: "BR-069", name: "Norwegian Elkhound", group: "Herding", aliases: [] },
  { id: "BR-070", name: "Old English Sheepdog", group: "Herding", aliases: [] },
  { id: "BR-071", name: "Pembroke Welsh Corgi", group: "Herding", aliases: ["Corgi"] },
  { id: "BR-072", name: "Shetland Sheepdog", group: "Herding", aliases: [] },
  { id: "BR-073", name: "Airedale Terrier", group: "Terrier", aliases: [] },
  { id: "BR-074", name: "American Staffordshire Terrier", group: "Terrier", aliases: [] },
  { id: "BR-075", name: "Australian Terrier", group: "Terrier", aliases: [] },
  { id: "BR-076", name: "Bedlington Terrier", group: "Terrier", aliases: [] },
  { id: "BR-077", name: "Boston Terrier", group: "Terrier", aliases: [] },
  { id: "BR-078", name: "Bull Terrier", group: "Terrier", aliases: [] },
  { id: "BR-079", name: "Cairn Terrier", group: "Terrier", aliases: [] },
  { id: "BR-080", name: "Dandie Dinmont Terrier", group: "Terrier", aliases: [] },
  { id: "BR-081", name: "Fox Terrier", group: "Terrier", aliases: [] },
  { id: "BR-082", name: "Irish Terrier", group: "Terrier", aliases: [] },
  { id: "BR-083", name: "Jack Russell Terrier", group: "Terrier", aliases: ["Parson Russell Terrier"] },
  { id: "BR-084", name: "Kerry Blue Terrier", group: "Terrier", aliases: [] },
  { id: "BR-085", name: "Miniature Schnauzer", group: "Terrier", aliases: [] },
  { id: "BR-086", name: "Norfolk Terrier", group: "Terrier", aliases: [] },
  { id: "BR-087", name: "Norwich Terrier", group: "Terrier", aliases: [] },
  { id: "BR-088", name: "Parson Russell Terrier", group: "Terrier", aliases: [] },
  { id: "BR-089", name: "Scottish Terrier", group: "Terrier", aliases: [] },
  { id: "BR-090", name: "Staffordshire Bull Terrier", group: "Terrier", aliases: [] },
  { id: "BR-091", name: "West Highland White Terrier", group: "Terrier", aliases: [] },
  { id: "BR-092", name: "Yorkshire Terrier", group: "Terrier", aliases: [] },
  { id: "BR-093", name: "Affenpinscher", group: "Toy", aliases: [] },
  { id: "BR-094", name: "Brussels Griffon", group: "Toy", aliases: [] },
  { id: "BR-095", name: "Cavalier King Charles Spaniel", group: "Toy", aliases: [] },
  { id: "BR-096", name: "Chihuahua", group: "Toy", aliases: [] },
  { id: "BR-097", name: "Chinese Crested", group: "Toy", aliases: [] },
  { id: "BR-098", name: "English Toy Spaniel", group: "Toy", aliases: [] },
  { id: "BR-099", name: "Japanese Chin", group: "Toy", aliases: [] },
  { id: "BR-100", name: "Havanese", group: "Toy", aliases: [] },
  { id: "BR-101", name: "Maltese", group: "Toy", aliases: [] },
  { id: "BR-102", name: "Miniature Pinscher", group: "Toy", aliases: [] },
  { id: "BR-103", name: "Papillon", group: "Toy", aliases: [] },
  { id: "BR-104", name: "Pekingese", group: "Toy", aliases: [] },
  { id: "BR-105", name: "Pomeranian", group: "Toy", aliases: [] },
  { id: "BR-106", name: "Pug", group: "Toy", aliases: [] },
  { id: "BR-107", name: "Russian Toy", group: "Toy", aliases: [] },
  { id: "BR-108", name: "Shih Tzu", group: "Toy", aliases: [] },
  { id: "BR-109", name: "Toy Fox Terrier", group: "Toy", aliases: [] },
  { id: "BR-110", name: "American Eskimo Dog", group: "NonSporting", aliases: [] },
  { id: "BR-111", name: "Bichon Frise", group: "NonSporting", aliases: [] },
  { id: "BR-112", name: "Bulldog", group: "NonSporting", aliases: [] },
  { id: "BR-113", name: "Chinese Shar-Pei", group: "NonSporting", aliases: [] },
  { id: "BR-114", name: "Chow Chow", group: "NonSporting", aliases: [] },
  { id: "BR-115", name: "Coton de Tulear", group: "NonSporting", aliases: [] },
  { id: "BR-116", name: "Dalmatian", group: "NonSporting", aliases: [] },
  { id: "BR-117", name: "French Bulldog", group: "NonSporting", aliases: ["Frenchie"] },
  { id: "BR-118", name: "Keeshond", group: "NonSporting", aliases: [] },
  { id: "BR-119", name: "Lhasa Apso", group: "NonSporting", aliases: [] },
  { id: "BR-120", name: "Poodle - Miniature", group: "NonSporting", aliases: ["Miniature Poodle"] },
  { id: "BR-121", name: "Poodle - Standard", group: "NonSporting", aliases: ["Standard Poodle"] },
  { id: "BR-122", name: "Poodle - Toy", group: "NonSporting", aliases: ["Toy Poodle"] },
  { id: "BR-123", name: "Schipperke", group: "NonSporting", aliases: [] },
  { id: "BR-124", name: "Tibetan Spaniel", group: "NonSporting", aliases: [] },
  { id: "BR-125", name: "Basenji", group: "Utility", aliases: [] },
  { id: "BR-126", name: "Canaan Dog", group: "Utility", aliases: [] },
  { id: "BR-127", name: "Eurasier", group: "Utility", aliases: [] },
  { id: "BR-128", name: "Finnish Spitz", group: "Utility", aliases: [] },
  { id: "BR-129", name: "Icelandic Sheepdog", group: "Utility", aliases: [] },
  { id: "BR-130", name: "Japanese Spitz", group: "Utility", aliases: [] },
  { id: "BR-131", name: "Kishu Ken", group: "Utility", aliases: [] },
  { id: "BR-132", name: "Lagotto Romagnolo", group: "Utility", aliases: [] },
  { id: "BR-133", name: "Shiba Inu", group: "Utility", aliases: [] },
  { id: "BR-134", name: "Xoloitzcuintli", group: "Utility", aliases: [] },
  { id: "BR-135", name: "Aussiedoodle", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-136", name: "Australian Labradoodle", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-137", name: "Bernedoodle", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-138", name: "Bordoodle", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-139", name: "Cavapoo", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-140", name: "Cockapoo", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-141", name: "Goldendoodle", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-142", name: "Irish Doodle", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-143", name: "Labradoodle", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-144", name: "Maltipoo", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-145", name: "Newfypoo", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-146", name: "Pomapoo", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-147", name: "Schnoodle", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-148", name: "Sheepadoodle", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-149", name: "Shih-poo", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-150", name: "Springerdoodle", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-151", name: "Whoodle", group: "Doodle / Poodle cross", aliases: [] },
  { id: "BR-900", name: "Mixed breed / crossbreed", group: "Special", aliases: ["Mix", "crossbreed", "rescue mix"] },
  { id: "BR-901", name: "Unknown / not sure", group: "Special", aliases: ["Unknown", "not sure"] },
] as const

export const DOG_BREEDS = DOG_BREED_CATALOG.map((entry) => entry.name)
export type DogBreed = (typeof DOG_BREEDS)[number]

export const DOODLE_BREED_NAMES = new Set(
  DOG_BREED_CATALOG.filter((entry) => entry.group === "Doodle / Poodle cross").map((entry) => entry.name),
)

function searchableText(entry: DogBreedEntry): string {
  return [entry.name, ...entry.aliases].join(" ").toLowerCase()
}

export function filterDogBreeds(query: string): DogBreedEntry[] {
  const normalized = query.trim().toLowerCase()
  if (!normalized) return [...DOG_BREED_CATALOG]
  return DOG_BREED_CATALOG.filter((entry) => searchableText(entry).includes(normalized))
}

export function isDogBreed(value: string): boolean {
  return (DOG_BREEDS as readonly string[]).includes(value)
}

export function resolveBreedSelection(query: string): { breed: string; mixDetail: string } | null {
  const normalized = query.trim().toLowerCase()
  if (!normalized) return { breed: "", mixDetail: "" }
  const exact = DOG_BREED_CATALOG.find((entry) => {
    if (entry.name.toLowerCase() === normalized) return true
    return entry.aliases.some((alias) => alias.toLowerCase() === normalized)
  })
  if (!exact) return null
  if (exact.group === "Doodle / Poodle cross") {
    return { breed: MIXED_BREED, mixDetail: exact.name }
  }
  return { breed: exact.name, mixDetail: "" }
}

export function displayBreedValue(breed: string, mixDetail?: string | null): string {
  if (breed === MIXED_BREED && mixDetail?.trim()) return mixDetail.trim()
  return breed
}

